<template>
  <MiniProduct />
  <AddToBag />
  <DataCollection
    v-if="showDataCollection"
    @follow-up="openMemberDiscountPopup"
  />
  <MemberDiscountPopup
    v-if="showDataCollection && memberDashboardPopupsEnabled"
    :open="memberPopupOpen"
    @close="memberPopupOpen = false"
  />
  <MemberBenefitsPopup
    v-if="showDataCollection && memberDashboardPopupsEnabled"
    :blocked="memberPopupOpen"
  />
  <DataCollectionTrigger v-if="showDataCollection" />
  <SelfidgesPopUP v-if="showSelfidgesPopup" />
  <CookieMessage v-if="!isPlaywright" />
  <WishlistLogin />
  <StockNotification />
</template>

<script>
import MiniProduct from "@/components/MiniProduct.vue";
import AddToBag from "@/components/add-to-bag/AddToBag.vue";
import DataCollection from "@/components/DataCollection.vue";
import DataCollectionTrigger from "@/components/DataCollectionTrigger.vue";
import MemberDiscountPopup from "@/components/MemberDiscountPopup.vue";
import MemberBenefitsPopup from "@/components/MemberBenefitsPopup.vue";
import SelfidgesPopUP from "@/components/SelfidgesPopUP.vue";
import CookieMessage from "@/components/CookieMessage.vue";
import WishlistLogin from "@/components/WishlistLogin.vue";
import StockNotification from "@/components/StockNotificationV2.vue";
import { getParams } from "@/helpers/url.js";
import { regionFeatureToggles } from "@/config.js";
import { getFeatureToggles } from "@/helpers/featureToggles.js";
import { mapGetters } from "vuex";

export default {
  name: "GlobalComponent",
  components: {
    AddToBag,
    DataCollection,
    DataCollectionTrigger,
    MemberDiscountPopup,
    MemberBenefitsPopup,
    SelfidgesPopUP,
    CookieMessage,
    WishlistLogin,
    MiniProduct,
    StockNotification,
  },
  inject: ["isPlaywright"],
  data() {
    return {
      memberPopupOpen: false,
    };
  },
  computed: {
    ...mapGetters("app", ["currencyCode"]),
    isUtmSource() {
      const params = getParams();
      const utmSource = params.utm_source;
      if (utmSource === "Klaviyo") {
        return true;
      }
      return false;
    },
    dataCollectionEnabled() {
      return regionFeatureToggles[this.currencyCode]?.dataCollectionEnabled;
    },
    showDataCollection() {
      if (!this.dataCollectionEnabled) {
        return false;
      }
      if (this.isPlaywright) {
        return false;
      }
      if (this.isUtmSource) {
        return false;
      }
      if (window.location.pathname === "/pages/flash-sale-signup") {
        return false;
      }
      return true;
    },
    memberDashboardPopupsEnabled() {
      const { memberDashboardPopupsEnabled = false } = getFeatureToggles();
      return memberDashboardPopupsEnabled;
    },
    showSelfidgesPopup() {
      const { self = false } = getFeatureToggles();
      if (!self) {
        return false;
      }
      if (this.isPlaywright) {
        return false;
      }
      if (window.location.pathname === "/pages/flash-sale-signup") {
        return false;
      }
      return true;
    },
  },
  methods: {
    openMemberDiscountPopup() {
      if (!this.memberDashboardPopupsEnabled) return;
      this.memberPopupOpen = true;
    },
  },
};
</script>
